<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Busca de dados do paciente no CADSUS"
    >
        <rkm-form>
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        label="Buscar por"
                        show-default-option
                        v-model="model.buscaPor"
                    >
                        <rkm-form-select-option
                            v-if="params && params.cns"
                            value="cns"
                        >
                            CNS
                        </rkm-form-select-option>

                        <rkm-form-select-option
                            v-if="params && params.cpf"
                            value="cpf"
                        >
                            CPF
                        </rkm-form-select-option>

                        <!--<rkm-form-select-option value="outros">Nome, Data de nascimento e Nome da mãe</rkm-form-select-option>-->
                    </rkm-form-select>
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :disabled="!model.buscaPor"
                        :label="false"
                        @click="search"
                        color="primary"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="clear"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields"
            :items="items"
        >

            <template v-slot:cell(logradouro)="{item}">
                {{item.logradouroTipo.descricao}} {{ item.logradouro && item.logradouro[0] ? item.logradouro[0] : '' }}
            </template>

            <template v-slot:cell(numero)="{item}">
                {{ item.numero && item.numero[0] ? item.numero[0] : 'S/N' }}
            </template>

            <template v-slot:cell(bairro)="{item}">
                {{ item.bairro && item.bairro[0] ? item.bairro[0] : '' }}
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    @click="update(item)"
                    color="primary"
                    small
                    title="Atualizar cadastro"
                >
                    <rkm-icon icon="check" />
                </rkm-button>
            </template>
        </rkm-table>

        <template v-slot:footer="{cancel}">
            <rkm-button
                @click="cancel"
                color="secondary"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, formats, repository, stringCase, unmask} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        fields() {
            return [
                {key: 'nome', label: 'Nome'},
                {filterByFormatted: true, formatter: value => this.formatDate(value), key: 'dataNascimento', label: 'Data de nascimento'},
                {key: 'sexo.descricao', label: 'Sexo'},
                {key: 'nomeMae', label: 'Nome da mãe'},
                {filterByFormatted: true, formatter: value => this.formatCns(value), key: 'cns', label: 'CNS'},
                {filterByFormatted: true, formatter: value => this.formatCpf(value), key: 'cpf', label: 'CPF'},
                {key: 'logradouro', label: 'Logradouro'},
                {key: 'numero', label: 'Número', class: 'col-min text-center'},
                {key: 'bairro', label: 'Bairro'},
                {key: 'municipio', label: 'Município'},
                {key: 'pais', label: 'País'},
                {key: 'cep', label: 'CEP', class: 'col-min text-center'},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ]
        },
    },
    created() {
        this.repositories = {
            cns: this.getConectaSusRepository('integracao.cns.cns'),
        }
    },
    data() {
        return {
            items: [],
            model: {
                buscaPor: null,
            },
            others: {moment},
            params: null,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(params) {
            this.reset()

            this.params = params
            this.$refs.RkmModal.show()
        },
        search() {
            if (this.model.buscaPor === 'cpf') {
                this.searchByCpf(this.params.cpf)
            }
            else if (this.model.buscaPor === 'cns') {
                this.searchByCns(this.params.cns)
            }
            else if (this.model.buscaPor === 'outros') {
                const request = {
                    nome: this.params.nomeMae,
                    dataNascimento: this.params.dataNascimento,
                    nomeMae: this.params.nomeMae,
                }

                this.searchBy(request)
            }
        },
        clear() {
            this.reset()
        },
        update(item) {
            this.showConfirmation(
                `Deseja realmente atualizar os dados do cidadão?<br><strong>Importante: </strong> o endereço do
                    paciente não será atualizado automaticamente e deverá ser ajustado manualmente no cadastro.`,
                async () => {
                    const request = {
                        nome: item.nome,
                        nomeSocial: item.nomeSocial,
                        dataNascimento: item.dataNascimento,
                        sexoId: item.sexo.id,
                        nomeMae: item.nomeMae,
                        nomePai: item.nomePai,
                        cns: item.cns,
                        cpf: item.cpf,
                        racaCorId: item.racaCor.id,
                        localNascimentoId: item.localNascimento.id,
                        telefones: item.telefones,
                        email: item.email,
                    }

                    this.setLoading()

                    this.repositories.cns.update(this.params.id, this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.showSaveNotification()
                            this.$emit('update', response.data)
                            this.$refs.RkmModal.hide()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
            )
        },
        searchByCns(value) {
            this.setLoading()

            this.repositories.cns.searchByCns(value)
                .then(response => this.items = response.data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        searchByCpf(value) {
            this.setLoading()

            this.repositories.cns.searchByCpf(value)
                .then(response => this.items = response.data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        searchBy(request) {
            this.setLoading()

            this.repositories.cns.searchBy(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.items = response.data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.items = []
            this.model.buscaPor = null
        },
    },
    mixins: [error, formats, repository, stringCase, unmask],
}
</script>